<template>
  <div class="load-hide bill">
    <div class="recharge_types" style="padding-top: 60px;">
      <pull-to-refresh disable-pulldown @on-pullup='onPullup'  class="page">
        <!--<div class="classic">历史记录</div>-->
        <div style="padding: 0 0.19rem 0.05rem">
          <table class="table table-bordered table-condensed dataTables-example dataTable no-footer">
            <tbody>
              <tr v-for="item in recordList">
                <td v-if="item.detail_type =='deposit'" class="shoppingtype redD"><p>{{getType[item.detail_type]}}</p></td>
                <td v-else-if="item.detail_type =='consume'" class="shoppingtype greenC"><p>{{getType[item.detail_type]}}</p></td>
                <td v-else-if="item.detail_type =='refund'" class="shoppingtype greyR"><p>{{getType[item.detail_type]}}</p></td>
                <td>
                  <div class="givetype">{{getKinds[item.coCode]}}</div>
                  <div style="text-align: left;color:#9e9e9e">{{item.gmt_create | date('%Y-%m-%d %H:%M:%s')}}</div>
                </td>
                <td v-if="item.detail_type == 'consume'" class="givetype" style="color:#6ab82d">-{{item.fee}}</td>
                <td v-else-if="item.detail_type =='deposit' && item.fee>=0" class="givetype" style="color:#bd0000">+{{item.fee}}</td>
                <td v-else-if="item.detail_type =='deposit' && item.fee<0" class="givetype" style="color:#bd0000">{{item.fee}}</td>
                <td v-else-if="item.detail_type =='refund'" class="givetype" style="color:#999999">+{{item.fee}}</td>
              </tr>
            </tbody>
          </table>
          <div v-if="recordList.length == 0" style="width: 100%;text-align: center;font-size:0.18rem;">暂无记录</div>
        </div>
      </pull-to-refresh>
      <!--<div class="bottom_refresh">向上滑动刷新</div>-->
    </div>
  </div>
</template>

<script>

import auth from '../../../lib/auth';
import constants from '../../../lib/constants';
import PullToRefresh from '../../../components/pull-to-refresh';
export default {
  data(){
      return{
        entity:{},
        recordList:[],
        page:1,
        size:6,
        getType:{
            "deposit":"充值",
            "consume":"消费",
            "refund":"退款"
        },
        getPayType:{
            "other":"其他支付",
            "card":"会员卡支付",
            "weixin":"微信支付",
            "cash":"现金支付",
            "alipay":"支付宝支付"
        },
        getKinds:{
            "PET":'门店消费',
            "PEO":"门店消费",
            "ECP":'卡充值订单',
            "MEP":'线上充值',
            "E":"商城消费",
            "EC":"商城充值",
            "F":"试吃消费",
            "G":"团购消费",
            "R":"退款",
            "dno":'普通充值',
            "esd":"商城充值"
        }
      }
  },
  mounted(){
    this.refresh(1);
  },
  components:{
    PullToRefresh
  },
  methods: {
    onPullup(finshCallback) {
      console.log('onPullup');
      setTimeout(()=>{
        console.log('finshCallback');
        this.size = this.size+10;
        this.refresh();
        finshCallback();//finish refreshing state
      },500);
    },
    refresh(page){
        console.log(this.size);
      this.$http.post(constants.API_HOST + constants.API_CARD_DETAIL_LIST, {
          page:this.page,
          size:this.size,
          entity:this.entity
      }).then((result) => {
        let data = result.data;
        if (data.code === "200") {
            this.recordList = data.data.dataList;
            for(var i=0;i<this.recordList.length;i++){
                var rl = this.recordList[i].co_nbr;
                var trl = rl.substring(-1,3);
                var srl = rl.substring(-1,2);
                var frl = rl.substring(1,0);
                if(trl == "PET" || trl == "ECP" || trl == "MEP" || trl == 'dno' || trl== 'PEO'){
                  this.recordList[i].coCode = trl;
                }else if(srl == "EC"){
                  this.recordList[i].coCode = srl;
                }else{
                  this.recordList[i].coCode = frl;
                }
            }
            console.log(this.recordList,111);
        }else {
          this.$alert(data.data);
        }
      }, (error) => {
        error.data && this.$alert(error.data);
      });
    }
  }

}

</script>

<style>

  body,html{
    height:100%;
  }
  html {
    font-size:90px!important
  }
  @media only screen and (min-width:319px) {
    html {
      font-size:100px!important
    }
  }@media only screen and (min-width:370px) {
    html {
      font-size:117px!important
    }
  }@media only screen and (min-width:414px) {
    html {
      font-size:129px!important
    }
  }
  @media only screen and (min-width:639px) {
    html {
      font-size:200px!important
    }
  }
  .classic{
    width:100%;
    background: #e8e8e8;
    text-align: center;
    height:50px;
    line-height:50px;
    font-size: 0.2rem;
  }
  .bill table,.bill tbody,.bill tr,.bill td{
    vertical-align: middle !important;
    border:0 !important;
    text-align: center;
  }
  .bill tr{
    border-bottom: 1px solid #e8e8e8 !important;
  }
  .shoppingtype{
    font-size:0.12rem;
  }

  .shoppingtype p{
    border: 1px solid #e8e8e8;
    padding: 14px 3px;
    font-weight: bold;
    color: #fff;
    border-radius: 8px;
    font-size: 0.18rem;
  }
  .shoppingtype.redD p{
    background: #bd0000;
  }
  .shoppingtype.greenC p{
    background: #6ab82d;
  }
  .shoppingtype.greyR p{
    background: #999999;
  }
  .givetype{
    font-size: 0.13rem;
    font-weight:bold;
    text-align: left;
    color:#252525
  }
  .recharge_types{
    background: #fff;
    min-height: 100%;
    padding: 0;
    overflow: auto;
  }

  .bottom_refresh{
    position: fixed;
    bottom:0;
    left:0;
    width:100%;
    height:0.6rem;
    background: #eff3f6;
    color:#78797a;
    text-align: center;
    line-height: 0.6rem;
    font-size:0.14rem;
  }

  /*滑动刷新*/
  .page{
    height: 600px;
    background: #fff;
    position: relative;
    /* Prevent native touch events on Windows */
    -ms-touch-action: none;
    /* Prevent the callout on tap-hold and text selection */
    -webkit-touch-callout: none;
    user-select: none;
    text-size-adjust: none;
  }
  #app {
    height: 100%;
    max-width: 400px;
    margin: 0 auto
  }
  ul{
    list-style: none;
    padding: 0px;
    margin: 0px
  }
  ul>li:nth-child(even){
    background-color: #fff
  }
  /*scrollbar start*/
  .iScrollVerticalScrollbar {
    position: absolute;
    z-index: 9999;
    width: 2px;
    bottom: 2px;
    top: 2px;
    right: 2px;
    overflow: hidden;
  }
  .iScrollVerticalScrollbar.iScrollBothScrollbars {
    bottom: 38px;
  }
  .iScrollIndicator {
    position: absolute;
    background: #999;
    border-radius: 6px;
    opacity: .8;
  }
  .iScrollVerticalScrollbar .iScrollIndicator {
    width: 100%;
    background: #999;
  }
  /*scrollbar end*/
</style>



// WEBPACK FOOTER //
// bill.vue?f4bc5c36